import { StyleSheet, Dimensions } from "react-native";

const ISTEST = false;
// const LOCALHOST_IP_ADDRESS = "192.168.13.151";
// const LOCALHOST_IP_ADDRESS = "192.168.43.163";
//  const LOCALHOST_IP_ADDRESS = '192.168.13.49'
// const LOCALHOST_IP_ADDRESS = "192.168.0.10";
// const LOCALHOST_IP_ADDRESS = "192.168.0.6"
const LOCALHOST_IP_ADDRESS = "192.168.43.170"
// const LOCALHOST_IP_ADDRESS = "192.168.13.120"
// const LOCALHOST_IP_ADDRESS = "192.168.13.181"

const SECRET_CODE = "ougigUpzuT5zRE96ntcEO5INGixXYx77vKHUbEuZxPlTp66K4P";

/*automate allocation_groups variable using salesforce metadata in phase 2 */
const variables = {
      global_font_specs: {
        // family: "Calibri",
        family: "14px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      },
      colors_array : ["rgb(111, 161, 111)", "orange", "rgb(145, 145, 131)", "rgb(106, 106, 230)","rgb(150, 73, 150)", "rgb(143, 208, 198)", "blue", "crimson", "rgb(77, 119, 126)", "#9acd32", ],
      allocation_group_field_dependencies: 
            {
                  "Resimax Internal" : ["Build To Rent","Leap Real Estate","Resimax - Hyde Property Group","Resimax - Hyde Sold","Resimax - Hyde Sold (Freedom Property Group)","Resimax - Nominated Developments","Resimax - Nominated Developments (Tick)","Resimax Reserved","Resimax Reserved - Local","Resimax Reserved - Not For Sale","Resimax Reserved - Universal","Resimax Staff"],
                  "Resimax Investor" : ["Channel - GEX","I-Sale Property Pty Ltd","Resimax - Local Investor","Resimax overseas"] ,
                  "Channel" : ["Channel - Accrue Real Estate","Channel - Afford Assist","Channel - Blue Wealth Property Group","Channel - Calla Property","Channel - Carter Capital Group","Channel - Castran Gilbert","Channel - Changing Places Real Estate","Channel - DHHS","Channel - Empire Property Investors","Channel - Freedom Property Investors","Channel - GEX","Channel - GSS Brothers Pty Ltd","Channel - Helping Hands Properties","Channel - Hess Real Estate","Channel - Infinity","Channel - iPAN","Channel - Ironfish Real Estate","Channel - Jinding Real Estate","Channel - Portal","Channel - Positive Income Properties","Channel - PSP","Channel - PSP Land Only","Channel - Stockdale & Leggo","Channel - Strategic Investors Australia","Channel - The A Team","Channel - United Homes Australia","Channel - VIC Real Estate"],
                  "Resimax Local" : ["OpenLot","Resimax - Firstly","Resimax - Home Builder","Resimax local","Resimax - Tickstart"],
                  "Builder" : ["Builder - ABN Group","Builder - Boutique Homes","Builder - Builder Pool","Builder - Central Property Group","Builder - Chatham Homes","Builder - GJ Gardner","Builder - Keogh Homes","Builder - Kingsbridge","Builder - Nostra Homes","Builder - Oreana Property Group","Builder Pool – Display Village","Builder Pool – Display Village 1","Builder Pool – Display Village 2","Builder - Simonds Homes","Builder - Test XX","Builder - VIC Constructions","Channel - GSS Brothers Pty Ltd","Channel - United Homes Australia","Tick Homes"],
                  "Upcoming" : ["Upcoming"]
            },
      CHART_HEIGHT: 200,
      FIXED_ROW_COUNT: 7,
      FIXED_COLUMN_COUNT: 5,
      CHART_WIDTH_COMPRESSED:  0.195,
      CHART_WIDTH: 0.245,
      showBordersFlag: false,
      chart_screenWidth : 500,
      pieChart_legendFontColor: '#7F7F7F',
      pieChart_legendFontSize: 13,
      pieChart_legendFontFamily:'Tahoma',
      color_palette: ["rgb(131, 167, 234)" , "rgb(16, 150, 24)", "rgb(220, 57, 18)", "rgb(153, 0, 153)", "rgb(0, 0, 255)" , "rgb(51, 102, 204)", "rgb(255, 153, 0", "maroon" , "lightgrey", "#ffa726" , "'#F00", "red", "#e26a00", "rgb(0, 0, 255)" , "lightgreen", "lightblue", "lightred" , "#fb8c00"],
      linedata_template : {
            labels: [],
            datasets: [
            {
            data: [],
            strokeWidth: 2, 
            },
            ],
      },

      lifecycle_stages : [
      'Available',
      'Reserved',
      'Contracted',
      'Sold',
      'Settled',
      'Site Start',
      'Slab',
      'Frame',
      'Lock Up',
      'Fix',
      'Final',
      'Settlement',
      'Advertised',
      'Leased',
      ],
      chartConfig :
      {
            backgroundColor: '#e26a00',
            backgroundGradientFrom: '#fb8c00',
            backgroundGradientTo: '#ffa726',
            decimalPlaces: 0, // optional, defaults to 2dp
            propsForLabels: {fontFamily: 'Helvetica', fontSize:10},
            color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
            style: {
                  borderRadius: 16
            },
            // propsForDots: {
            //       r: "6",
            //       strokeWidth: "2",
            //       stroke: "#fbfbfb"
            // }            
      },
null_screen_data : [{"key":0.1131596286752651,"fieldapiname":"totalactivetranches","labelname":"","value":0},{"key":0.044372744072521134,"fieldapiname":"totallandsettled","labelname":"Land","value":0}, {"key":0.044372744072521134,"fieldapiname":"totalhousesettled","labelname":"House","value":0}, {"key":0.06364857575520935,"fieldapiname":"totalsettlementclaims","labelname":"","value":0},{"key":0.001866966124390844,"fieldapiname":"leased","labelname":"","value":0},{"key":0.0181763311708736,"fieldapiname":"totallots","labelname":"Count","value":0},{"key":0.0181763311708732,"fieldapiname":"totalhouseandlandlots","labelname":"Count","value":0},{"key":0.0181763311708733,"fieldapiname":"totalpropertylots","labelname":"Count","value":0},{"key":0.041759831154551084,"fieldapiname":"totallandprice","labelname":"Land","value":0},{"key":0.028733040515356256,"fieldapiname":"totalbuildprice","labelname":"Build","value":0},{"key":0.12795464313500368,"fieldapiname":"totalpropertyprice","labelname":"Property","value":0},{"key":0.20793263032081574,"fieldapiname":"totalvalue","labelname":"Total","value":0},{"key":0.03762023118119857,"fieldapiname":"totallandsize","labelname":"Land","value":0},{"key":0.001223692789495821,"fieldapiname":"totalhousesize","labelname":"Build","value":0},{"key":0.11317618450667259,"fieldapiname":"totalpropertysize","labelname":"Property","value":0},{"key":0.2253707731991182,"fieldapiname":"size","labelname":"Total","value":0},{"key":0.08124191678636113,"fieldapiname":"totallandvaluation","labelname":"Land","value":0},{"key":0.014697899654692145,"fieldapiname":"totalhousevaluation","labelname":"Build","value":0},{"key":0.04745195732184118,"fieldapiname":"totalpropertyvaluation","labelname":"Property","value":0},{"key":0.031412249586490824,"fieldapiname":"valuation","labelname":"Total","value":0},{"key":0.07404830828937915,"fieldapiname":"valuationdifference","labelname":"","value":0}],
DEFAULT_PRODUCT_TYPE_FILTER: {houseandland: true,townhouse: true},
  screen1_metrics: [
    {
      key:1,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "orange",
      icon: "line-chart",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}
    },
    {
      key:2,
      labelname: "Total Lots",
      apiname: "totallots",
      count: 1,
      color: "rgb(143, 208, 198)",
      icon: "object-ungroup",
      filterParms: {}
    },
      {
      key:3,
      labelname: "Land Settled",
      apiname: "totallandsettled",
      count: 1,
      color: "blue",
      icon: "font-awesome",
      filterParms: {sfid: null, sfname: 'Land Settled', fc_from_card: 'milestone'}
    },
    {
      key:4,
      labelname: "Total Settlement Claims",
      apiname: "totalsettlementclaims",
      count: 1,
      color: "crimson",
      icon: "key",
      filterParms: [{sfid: null, sfname: 'Leased', fc_from_card: 'milestone'},{sfid: null, sfname: 'Build Settled', fc_from_card: 'milestone'},{sfid: null, sfname: 'Advertised', fc_from_card: 'milestone'}]

    },
      {
      key:5,
      labelname: "House Settled",
      apiname: "totalhousesettled",
      count: 1,
      color: "rgb(77, 119, 126)",
      icon: "gavel",
      filterParms: [{sfid: null, sfname: 'Leased', fc_from_card: 'milestone'},{sfid: null, sfname: 'Build Settled', fc_from_card: 'milestone'},{sfid: null, sfname: 'Advertised', fc_from_card: 'milestone'}]

    },
    {
      key:6,
      labelname: "Leased",
      apiname: "leased",
      count: 1,
      color: "#9acd32",
      icon: "home",
      filterParms: {sfid: null, sfname: 'Leased', fc_from_card: 'milestone'}

    },
    {
      key:7,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "orange",      
      icon: "line-chart",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}      
    },
        {
      key:8,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "orange",      
      icon: "font-awesome",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}      
    },
        {
      key:9,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "orange",      
      icon: "object-ungroup",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}      
    },
    {
      key:10,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "#9acd32",      
      icon: "object-ungroup",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}      
    },
    {
      key:11,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "#9acd32",      
      icon: "object-ungroup",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}      
    },
    {
      key:12,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "#9acd32",      
      icon: "object-ungroup",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}      
    },
    {
      key:13,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "#9acd32",      
      icon: "object-ungroup",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}      
    },
    {
      key:14,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "#9acd32",      
      icon: "object-ungroup",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}      
    },
    {
      key:15,
      labelname: "Active Tranches",
      apiname: "totalactivetranches",
      count: 1,
      color: "#9acd32",      
      icon: "object-ungroup",
      filterParms: {sfid: null, sfname: 'Settled', fc_from_card: 'status'}      
    }
  ],

  screen2_metrics_row_1: [
    {
      key:10,
      labelname: "Count",
      apiname: "totallots",
      boxname: "count",
      // colors: ["orange"],
      value: 500,
      metric: "",
      // color: "rgb(255, 179, 0)"
      // color: "green"
      color: "rgb(111, 161, 111)"
    },
//     {
//       key:2,
//       labelname: "Val. Difference",
//       apiname: "valuationdifference",
//       colors: ["red"],
//       value: 600,
//     },
    {
      key:2,
      labelname: "Price",
      apiname: "totalvalue",
      value: 700,
      metric: "Price",
      color: "orange"

    },
        {
      key:3,
      labelname: "Size",
      apiname: "size",
      value: 800,
      metric: "Size",
      // color: "#9acd32"
      color: "orange"

    },
    {
      key:4,
      labelname: "Valuation",
      apiname: "valuation",
      value: 900,
      metric: "Valuation",
      color: "orange"


    },
  ],
  screen2_metrics_row_2: [
//     {
//       key:3,
//       labelname: "Price",
//       apiname: "totalvalue",
//       colors: ["green"],
//       value: 700,
//     },
//     {
//       key:4,
//       labelname: "Size",
//       apiname: "size",
//       colors: ["blue"],
//       value: 800,
//     },
//     {
//       key:5,
//       labelname: "Valuation",
//       apiname: "valuation",
//       colors: ["purple"],
//       value: 900,
//     },

    {
      key:5,
      labelname: "Land",
      apiname: "totallandprice",
      value: 700,
      metric: "Price",
      color: "rgb(145, 145, 131)",
    },
    {
      key:6,
      labelname: "Build",
      apiname: "totalbuildprice",
      value: 800,
      metric: "Price",
      color: "rgb(106, 106, 230)",

    },
    {
      key:7,
      labelname: "Property",
      apiname: "totalpropertyprice",
      value: 900,
      metric: "Price",
      color: "rgb(150, 73, 150)",
    },

        {
      key:8,
      labelname: "Land",
      apiname: "totallandsize",
      value: 700,
      metric: "Size",
      color: "rgb(145, 145, 131)",

    },
    {
      key:9,
      labelname: "Build",
      apiname: "totalhousesize",
      value: 800,
      metric: "Size",
      color: "rgb(106, 106, 230)",
      

    },
    {
      key:10,
      labelname: "Property",
      apiname: "totalpropertysize",
      value: 900,
      metric: "Size",
      color: "rgb(150, 73, 150)",
    },

        {
      key:11,
      labelname: "Land",
      apiname: "totallandvaluation",
      value: 700,
      metric: "Valuation",
      color: "rgb(145, 145, 131)",

    },
    {
      key:12,
      labelname: "Build",
      apiname: "totalhousevaluation",
      value: 800,
      metric: "Valuation",
      color: "rgb(106, 106, 230)",

    },
    {
      key:13,
      labelname: "Property",
      apiname: "totalpropertyvaluation",
      value: 900,
      metric: "Valuation",
      color: "rgb(150, 73, 150)",
    },

  ],
  PRODUCT_TYPE_H_PLUS_L: "House and Land",
  PRODUCT_TYPE_TOWNHOUSE: "TownHouse",
  CONTRACT_TYPE_LAND_OR_PROPERTY: "land or property contract",
  CONTRACT_TYPE_BUILD: "build contract",
  SETTLEMENT_TYPE_CLAIM: "settlement claim",
  METRIC_TAG_PRICE: "Price",
  METRIC_TAG_VALUATION: "Valuation",
  METRIC_TAG_SIZE: "Size",
  localhost_ip_address: LOCALHOST_IP_ADDRESS,
  base_url: ISTEST
    ? "http://" + LOCALHOST_IP_ADDRESS + ":3000/"
    // : "https://btr-app.herokuapp.com/",
    : "https://btr-app-93fe01ab7384.herokuapp.com/" ,
  secret_code: SECRET_CODE,
  isDesktop: Dimensions.get("window").width > 1000 ? true : false,
    isTest: ISTEST,
   iconSize : Dimensions.get("window").width > 1000 ? 20 : 30,
      iconSizeLotListCard : 16,
  url_config: [
    { function: "data-fetch", urlsuffix: "sfapi" },
    { function: "concentration-report", urlsuffix: "concentration_report" },
  ],

dummy_test_data_export_to_excel_function : 
  [
    {"attributes":{"type":"Product2","url":"/services/data/v42.0/sobjects/Product2/01t7F000005ScHGQA0"},"Id":"01t7F000005ScHGQA0","DateProductAllocated__c":"2021-05-12","ProductAllocatedTo__c":"Build To Rent","AllocationGroup__c":"Resimax Internal","Trancher__c":"5","LandSize__c":195,"Name":"Lot 039 FC","Project__c":"a027F00000SM81vQAD","Stage__c":"a037F00000gSj3jQAC","Stage__r":{"attributes":{"type":"Stage__c","url":"/services/data/v42.0/sobjects/Stage__c/a037F00000gSj3jQAC"},"Name":"Findon Creek - Stage 2"},"Project__r":{"attributes":{"type":"Project__c","url":"/services/data/v42.0/sobjects/Project__c/a027F00000SM81vQAD"},"Name":"Findon Creek PROJECT","ActiveforReporting__c":true},"ProductType__c":"Land","Price__c":239000,"Status__c":"Withheld","StatusDEV__c":"Withheld","StatusDevr__c":"Withheld","LandSize_r__c":195,"LandPrice_r__c":239000,"Nominated_Pty_Development_Lot__c":false,"StreetNumber__c":"13","StreetName__c":"Mahla AVENUE","Suburb__c":"Wollert","State__c":"VIC","Postcode__c":"3750","Milestone__c":"Withheld","MasterContractType__c":null,"LandDepth__c":6.2,"LandFrontage__c":31.38,"IsCornerLot__c":false,"IsIrregularLot__c":false,"Volume__c":"12170","FolioNo__c":"737","Municipality__c":null,"LP__c":null,"PS__c":"745033","ProjectVendor__c":"TBA Project Vendor"},
    {"attributes":{"type":"Product2","url":"/services/data/v42.0/sobjects/Product2/01t7F000005ScHGQA0"},"Id":"01t7F000005ScHGQA0","DateProductAllocated__c":"2021-05-12","ProductAllocatedTo__c":"Build To Rent","AllocationGroup__c":"Resimax Internal","Trancher__c":"5","LandSize__c":195,"Name":"Lot 039 FC","Project__c":"a027F00000SM81vQAD","Stage__c":"a037F00000gSj3jQAC","Stage__r":{"attributes":{"type":"Stage__c","url":"/services/data/v42.0/sobjects/Stage__c/a037F00000gSj3jQAC"},"Name":"Findon Creek - Stage 2"},"Project__r":{"attributes":{"type":"Project__c","url":"/services/data/v42.0/sobjects/Project__c/a027F00000SM81vQAD"},"Name":"Findon Creek PROJECT","ActiveforReporting__c":true},"ProductType__c":"Land","Price__c":239000,"Status__c":"Withheld","StatusDEV__c":"Withheld","StatusDevr__c":"Withheld","LandSize_r__c":195,"LandPrice_r__c":239000,"Nominated_Pty_Development_Lot__c":false,"StreetNumber__c":"13","StreetName__c":"Mahla AVENUE","Suburb__c":"Wollert","State__c":"VIC","Postcode__c":"3750","Milestone__c":"Withheld","MasterContractType__c":null,"LandDepth__c":6.2,"LandFrontage__c":31.38,"IsCornerLot__c":false,"IsIrregularLot__c":false,"Volume__c":"12170","FolioNo__c":"737","Municipality__c":null,"LP__c":null,"PS__c":"745033","ProjectVendor__c":"TBA Project Vendor"}
  ]


};

export { variables };

// const SERVER_URL_PRODUCTION =
//   "https://btr-app.herokuapp.com/sfapi?code=" +
//   "ougigUpzuT5zRE96ntcEO5INGixXYx77vKHUbEuZxPlTp66K4P";
// const SERVER_URL_TEST =
//   "http://" + LOCALHOST_IP_ADDRESS + ":3000/sfapi?code=" +
//   "ougigUpzuT5zRE96ntcEO5INGixXYx77vKHUbEuZxPlTp66K4P";
// export { SERVER_URL_PRODUCTION };
// export { SERVER_URL_TEST };
